// extracted by mini-css-extract-plugin
export default {"phoneFooter":"PhoneChangeForm_phoneFooter__Oseeb"};